module.exports = __webpack_public_path__ + "static/media/ach-bank.6d8e65ab.svg";